// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="#DC2C20"
      d="M4.00009 7C2.50009 7 2.00009 7.5 2.00009 7.5V1.5C2.00009 1.5 2.50009 1 4.00009 1C5.50009 1 6.50009 2 8.00009 2C9.50009 2 10.0001 1.5 10.0001 1.5V7.5C10.0001 7.5 9.50009 8 8.00009 8C6.50009 8 5.50009 7 4.00009 7Z"
    />
    <path
      stroke="#DC2C20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.167}
      d="M2.00009 7.5C2.00009 7.5 2.50009 7 4.00009 7C5.50009 7 6.50009 8 8.00009 8C9.50009 8 10.0001 7.5 10.0001 7.5V1.5C10.0001 1.5 9.50009 2 8.00009 2C6.50009 2 5.50009 1 4.00009 1C2.50009 1 2.00009 1.5 2.00009 1.5L2.00009 11"
    />
  </svg>
);
const IconFlag = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconFlag;
